// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-11-02 14:09:36 +0100 (Sun, 02 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 157721 $
//  Purpose   : glossary parts
// =============================================================================
import React from 'react'

import {loadLazy as ll, funcPart} from 'uix/parts'

export const GlossaryManager = ll(() => import(/* webpackChunkName: 'fulltext' */ './glossary'))
